import React, { useState, useContext } from "react"
import { Navigate, Route, Routes as SwitchRoutes, useLocation } from "react-router-dom"
import { Snackbar, Alert, Backdrop, CircularProgress } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import useMediaQuery from "@mui/material/useMediaQuery"
import ActivePositions from "./MyBooks/ActivePositions"
import ChatRoot from "./Chat/ChatRoot"
import Search from "./Search/Search"
import History from "./History/History"
import {
  F_TRADING_ACTIVE_SHORT,
  F_TRADING_CHAT_SHORT,
  F_TRADING_HISTORY_SHORT,
  F_TRADING_SEARCH,
  F_TRADING_SEARCH_SHORT,
} from "../../constants/routes"
import BackdropContext from "../../context/BackdropContext"
import StateProvider from "../../context/StateProvider"
import RootContainer from "./RootContainer"

const Trading = () => {
  const location = useLocation()
  const { backdropOpen } = useContext(BackdropContext)

  const [snackbarMsg, setSnackbarMsg] = useState(null)

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))

  const props = {
    isMobile: isMobile,
    setSnackbarMsg: setSnackbarMsg,
  }

  return (
    <StateProvider>
      <RootContainer>
        <SwitchRoutes location={location}>
          <Route path="/" element={<Navigate to={F_TRADING_SEARCH} replace />} />

          <Route path={F_TRADING_SEARCH_SHORT} element={<Search {...props} />} />
          <Route path={F_TRADING_ACTIVE_SHORT} element={<ActivePositions {...props} />} />
          <Route path={F_TRADING_CHAT_SHORT} element={<ChatRoot {...props} />} />
          <Route path={F_TRADING_HISTORY_SHORT} element={<History {...props} />} />

          <Route path="*" element={<Search {...props} />} />
        </SwitchRoutes>

        <Snackbar
          sx={{ color: "secondary.main" }}
          open={!!snackbarMsg}
          autoHideDuration={10000}
          onClose={(_, reason) => {
            if (reason === "clickaway") return
            setSnackbarMsg(null)
          }}>
          <Alert
            onClose={() => {
              setSnackbarMsg(null)
            }}
            severity="success"
            sx={{ width: "100%" }}>
            {snackbarMsg}
          </Alert>
        </Snackbar>

        <Backdrop sx={(theme) => ({ backgroundColor: "rgba(0,0,0,0.1)", zIndex: theme.zIndex.drawer + 1 })} open={backdropOpen}>
          <CircularProgress size={60} thickness={5} color="secondary" />
        </Backdrop>
        {/* </Box> */}
        {/* </Box> */}
      </RootContainer>
    </StateProvider>
  )
}

export default Trading
